export default class CompanyUser {

  removeLink (){
    if (window.location.pathname === "/company_user_password_resets/iforgot") {
      $('.navbar-sidenav').remove();
      $('li#nav-login').remove();
      $('li#nav-contact').remove();
    }
  }

  revealApi() {
    $("#job-posting-api-key").show();
    $("#show-api-btn").hide();
  }
}
